export default __webpack_public_path__ + "static/IMAGEM_3-486e50b7fc5af34911ad3b25214a6f85.png";